import { history } from '../store/store';

export const routeWithQueryParam = ({ key, value = null }) => {
  const path = history.location.pathname;
  history.push(value ? path.concat(`?${key}=${value}`) : path);
};

export const getQueryParam = ({ key }) => new URLSearchParams(history.location.search).get(key);
